(function() {
  var initializedAttr = 'data-boat-builder-initialized';

  function initAll() {
    var builders = document.querySelectorAll('[data-boat-builder]:not([' + initializedAttr + '])');
    builders.forEach(initBuilder);
  }

  function parseConfig(root) {
    var el = root.querySelector('script[data-builder-config]');
    if (!el) {
      return null;
    }

    try {
      var parsed = JSON.parse(el.textContent);
      if (!parsed || !parsed.groups || !parsed.options) {
        return null;
      }
      parsed.boats = parsed.boats || {};
      parsed.packages = parsed.packages || {};
      parsed.standardEquipment = parsed.standardEquipment || {};
      return parsed;
    } catch (err) {
      console.warn('boat-builder: could not parse builder config', err);
      return null;
    }
  }

  function buildPoolMembers(config) {
    var pools = {};
    if (!config) {
      return pools;
    }

    Object.keys(config.options).forEach(function(sku) {
      var option = config.options[sku];
      if (option.maxQtyMode === 'boat_limit' && option.poolKey) {
        pools[option.poolKey] = pools[option.poolKey] || [];
        pools[option.poolKey].push(sku);
      }
    });

    return pools;
  }

  function initBuilder(root) {
    root.setAttribute(initializedAttr, 'true');

    var config = parseConfig(root);
    var poolMembers = buildPoolMembers(config);
    var groupsById = {};
    if (config) {
      config.groups.forEach(function(group) {
        groupsById[group.id] = group;
      });
    }

    var state = {
      step: 1,
      base: null,
      boatProductId: '',
      selections: {},
      includedQty: {},
      includedPackageId: '',
      credits: [],
      options: [],
      texas: false,
      publicWaters: false,
      subtotal: 0,
      tax: 0,
      fees: [],
      feesTotal: 0,
      total: 0,
      shipping: { status: 'idle', amount: null, title: '', zip: '', city: '', variantId: '' }
    };

    var view = {};
    var warnedLimits = {};

    var taxRate = parseFloat(root.dataset.taxRate || '0');
    if (isNaN(taxRate)) {
      taxRate = 0;
    }

    // Freight estimate via the Storefront API (throwaway cart + carrier rates).
    // Fail closed: without the merchant toggle AND a token, none of the
    // shipping code runs and the builder behaves exactly as before.
    // Only the PUBLIC Storefront token works client-side; shp??_-prefixed
    // tokens (shpss_ private, shpat_ admin) are secrets, get 401s on the
    // public header, and must never ship in theme markup — refuse them.
    var storefrontToken = (root.dataset.storefrontToken || '').trim();
    if (/^shp[a-z]{2}_/.test(storefrontToken)) {
      console.warn('boat-builder: the configured Storefront token looks like a PRIVATE/admin token (' + storefrontToken.slice(0, 6) + '…). Paste the public Storefront access token instead; freight estimates are disabled and the pasted secret should be rotated.');
      storefrontToken = '';
    }
    var shippingCfg = {
      enabled: root.dataset.shippingEstimateEnabled === 'true' && Boolean(storefrontToken),
      token: storefrontToken,
      apiVersion: root.dataset.storefrontApiVersion || '2026-07',
      country: (root.dataset.shippingCountry || 'US').toUpperCase(),
      fallbackText: root.dataset.shippingFallbackText || ''
    };
    // 'variantId:zip:city' -> settled shipping state, so repeat lookups are free.
    // City is part of the key because it is part of the rated address: a rate
    // for Dallas 75001 is not a rate for Houston 75001.
    var shippingCache = {};
    var shippingAbort = null;
    var shippingSeq = 0; // discards stale responses when AbortController is unavailable
    var shippingDebounce = null;
    var shippingErrorAt = 0; // last transient failure; retried after a cooldown or on blur

    // Builder lead capture: when a shopper completes the contact fields with a
    // boat selected, upsert them into HubSpot as a lead — even if they never
    // place the deposit. Uses the client-side HubSpot Forms API (no server, no
    // secret); HubSpot dedupes the contact by email, so a lead that later
    // converts merges with the deposit deal the webhook Lambda creates. Fail
    // closed: nothing runs unless the merchant enables it AND supplies both a
    // Hub (portal) id and a form GUID.
    var leadCfg = {
      enabled: root.dataset.builderLeadEnabled === 'true'
        && Boolean((root.dataset.hubspotPortalId || '').trim())
        && Boolean((root.dataset.hubspotFormGuid || '').trim()),
      portalId: (root.dataset.hubspotPortalId || '').trim(),
      formGuid: (root.dataset.hubspotFormGuid || '').trim()
    };
    var leadDebounce = null;
    var lastLeadSignature = ''; // skips resubmitting an unchanged build
    var leadInFlight = false;

    function dollarsToCents(value) {
      var n = parseFloat(value);
      if (isNaN(n) || n < 0) {
        return 0;
      }
      return Math.round(n * 100);
    }

    // Flat Texas title/registration fees, added to the estimate when the Texas
    // toggle is on (and, for trailer/outboard/public-waters, when their trigger
    // is met). Amounts come from the section settings (dollars → cents).
    var texasFees = {
      boat: {
        amount: dollarsToCents(root.dataset.txBoatFee),
        label: root.dataset.txBoatFeeLabel || 'Boat title & filing fee'
      },
      trailer: {
        amount: dollarsToCents(root.dataset.txTrailerFee),
        label: root.dataset.txTrailerFeeLabel || 'Trailer registration fee',
        group: root.dataset.txTrailerGroup || 'trailer'
      },
      outboard: {
        amount: dollarsToCents(root.dataset.txOutboardFee),
        label: root.dataset.txOutboardFeeLabel || 'Outboard title & filing fee',
        group: root.dataset.txOutboardGroup || 'outboard-motor'
      },
      publicWaters: {
        amount: dollarsToCents(root.dataset.txPublicWatersFee),
        label: root.dataset.txPublicWatersFeeLabel || 'Public waters registration fee'
      }
    };

    var selectors = {
      stepButton: '[data-step-button]',
      stepPanel: '[data-step-panel]',
      modelInput: '[data-model-input]',
      baseInput: '[data-base-input]',
      optionInput: '[data-option-input]',
      optionQuantity: '[data-option-quantity]',
      texasToggle: '[data-texas-toggle]',
      publicWaters: '[data-public-waters]',
      deposit: '[data-deposit]',
      message: '[data-form-message]'
    };

    root.addEventListener('click', function(evt) {
      var stepButton = evt.target.closest(selectors.stepButton);
      var goStepButton = evt.target.closest('[data-go-step]');
      var minusButton = evt.target.closest('[data-quantity-minus]');
      var plusButton = evt.target.closest('[data-quantity-plus]');
      var depositButton = evt.target.closest('[data-place-deposit]');

      if (stepButton) {
        setStep(parseInt(stepButton.dataset.stepButton, 10));
        scrollToSteps();
        return;
      }

      if (goStepButton) {
        setStep(parseInt(goStepButton.dataset.goStep, 10));
        scrollToSteps();
        return;
      }

      if (minusButton || plusButton) {
        var quantityInput = evt.target.closest('.boat-builder__quantity-control').querySelector(selectors.optionQuantity);
        if (!quantityInput || quantityInput.disabled) {
          return;
        }
        var sku = quantityInput.dataset.sku;
        var next = Math.max(0, qtyOf(sku) + (plusButton ? 1 : -1));
        var max = view[sku] ? view[sku].max : null;
        if (max !== null && max !== undefined) {
          // Same ceiling the rules engine and the +/- disabling use: included
          // items may sit above the pool max (e.g. 2 included seats on a full
          // pool), and clamping to the raw max would either no-op an enabled
          // "+" or collapse a floored quantity to zero.
          var ceiling = Math.max(max, includedQtyOf(sku));
          if (next > ceiling) {
            next = ceiling;
          }
        }
        setUserQty(sku, next);
        updateState();
        return;
      }

      if (depositButton) {
        placeDeposit(depositButton);
      }
    });

    root.addEventListener('change', function(evt) {
      if (evt.target.matches(selectors.modelInput)) {
        handleModelChange(evt.target);
        updateState();
        revealPackages(evt.target);
        return;
      }

      if (evt.target.matches(selectors.optionInput)) {
        handleOptionChange(evt.target);
        updateState();
        return;
      }

      if (evt.target.matches(selectors.optionQuantity)) {
        var qty = parseInt(evt.target.value || '0', 10);
        if (isNaN(qty) || qty < 0) {
          qty = 0;
        }
        setUserQty(evt.target.dataset.sku, qty);
        updateState();
        return;
      }

      if (
        evt.target.matches(selectors.baseInput) ||
        evt.target.matches(selectors.texasToggle) ||
        evt.target.matches(selectors.publicWaters)
      ) {
        updateState();
      }
    });

    bindPhoneFormatter();
    bindAddressEstimator();
    bindLeadCapture();

    try {
      var boatFromUrl = applyBoatFromUrl();
      if (!boatFromUrl) {
        chooseDefaultModel();
      }
      updateState();
      if (boatFromUrl) {
        setStep(2);
      }
    } finally {
      markReady();
    }

    function prefersReducedMotion() {
      return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    // Bring the step tabs (and the panel below them) back into view when the
    // customer moves between steps, so a shorter panel (e.g. step 3) doesn't
    // leave them staring at the footer.
    function scrollToSteps() {
      var anchor = root.querySelector('.boat-builder__steps') || root;
      if (anchor && typeof anchor.scrollIntoView === 'function') {
        anchor.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function bindPhoneFormatter() {
      var phone = root.querySelector('[data-contact-phone]');
      if (!phone) {
        return;
      }
      phone.addEventListener('input', function() {
        phone.value = formatPhone(phone.value);
      });
    }

    // Progressive US phone formatting as the customer types: (123) 456-7890,
    // with an optional leading country code. Non-digits are stripped, so
    // backspacing through formatting characters behaves naturally.
    function formatPhone(value) {
      var digits = String(value || '').replace(/\D/g, '');
      var country = '';
      if (digits.length > 10 && digits.charAt(0) === '1') {
        country = '1 ';
        digits = digits.slice(1);
      }
      digits = digits.slice(0, 10);

      if (digits.length === 0) {
        return country.trim();
      }
      if (digits.length < 4) {
        return country + '(' + digits;
      }
      if (digits.length < 7) {
        return country + '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
      }
      return country + '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    }

    // Freight estimate triggers. Both the city and the ZIP are rated, so
    // either one changing re-quotes — but only the ZIP quotes while typing:
    // the 5-digit regex proves it is complete, whereas a half-typed city
    // ("Hous") is a real-looking address that rates wrong. City therefore
    // quotes on blur only. Blur also forces a retry even during the
    // transient-error cooldown.
    function bindAddressEstimator() {
      if (!shippingCfg.enabled) {
        return;
      }
      var zipField = root.querySelector('[data-contact-zip]');
      var cityField = root.querySelector('[data-contact-city]');
      if (zipField) {
        zipField.addEventListener('input', function() {
          clearTimeout(shippingDebounce);
          shippingDebounce = setTimeout(function() {
            maybeFetchShippingEstimate(false);
          }, 600);
        });
      }
      Array.prototype.forEach.call([zipField, cityField], function(field) {
        if (!field) {
          return;
        }
        field.addEventListener('blur', function() {
          clearTimeout(shippingDebounce);
          maybeFetchShippingEstimate(true);
        });
      });
    }

    // Deep links into the builder. Two parameters, most specific first:
    //   ?variant=<package variant id>  preselect that exact package (and its model)
    //   ?boat=<product handle|id>      preselect the model, default package
    // Returns true when either matched, which is what makes init jump to step 2.
    function applyBoatFromUrl() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (err) {
        return false;
      }

      // A package implies its model, so ?variant= wins when both are present.
      // `data-id` on a package radio is the bare numeric variant id — the same
      // value Shopify puts in ?variant= on the product page, so package CTAs can
      // hand their variant straight over.
      var variantParam = (params.get('variant') || '').trim();
      if (variantParam) {
        var base = root.querySelector(
          selectors.baseInput + '[data-id="' + escapeAttr(variantParam) + '"]:not(:disabled)'
        );
        if (base) {
          var model = root.querySelector(
            selectors.modelInput + '[data-product-id="' + escapeAttr(base.dataset.modelId || '') + '"]'
          );
          if (model) {
            model.checked = true;
            // Reveals the package panel AND preselects that model's DEFAULT
            // package, so the explicit pick has to be applied after it.
            handleModelChange(model);
          }
          base.checked = true;
          return true;
        }
        // Unknown or sold-out variant: fall through to ?boat=, then to the
        // default model, rather than dead-ending on step 1 with nothing chosen.
      }

      var param = (params.get('boat') || '').toLowerCase();
      if (!param) {
        return false;
      }

      var models = root.querySelectorAll(selectors.modelInput);
      for (var i = 0; i < models.length; i++) {
        if (
          (models[i].dataset.productId || '') === param ||
          (models[i].dataset.productHandle || '').toLowerCase() === param
        ) {
          models[i].checked = true;
          handleModelChange(models[i]);
          return true;
        }
      }
      return false;
    }

    // Show models first; only drill into a package if a model is flagged as default.
    function chooseDefaultModel() {
      var defaultModel = root.querySelector(selectors.modelInput + '[data-default="true"]');
      if (defaultModel) {
        defaultModel.checked = true;
        handleModelChange(defaultModel);
      }
    }

    // Reveal the selected model's package panel (when it has more than one package)
    // and preselect a default package so the summary and the Customize button update.
    function handleModelChange(modelInput) {
      var productId = modelInput.dataset.productId || '';

      root.querySelectorAll('[data-model-packages]').forEach(function(panel) {
        var match = panel.dataset.modelPackages === productId;
        var count = panel.querySelectorAll(selectors.baseInput + ':not(:disabled)').length;
        panel.hidden = !(match && count > 1);
      });

      var checked = root.querySelector(selectors.baseInput + ':checked');
      if (checked && checked.dataset.modelId === productId) {
        return;
      }

      var inputs = root.querySelectorAll(
        selectors.baseInput + '[data-model-id="' + escapeAttr(productId) + '"]:not(:disabled)'
      );
      var pick = null;
      inputs.forEach(function(input) {
        if (!pick && input.dataset.defaultPackage === 'true') {
          pick = input;
        }
      });
      if (!pick && inputs.length) {
        pick = inputs[0];
      }
      if (pick) {
        pick.checked = true;
      } else if (checked) {
        checked.checked = false;
      }
    }

    // After the customer picks a model, slide the package panel (or, for a
    // single-package model, the Customize action) into view so the next step
    // is obvious. Only runs on a real user pick (programmatic checks don't fire change).
    function revealPackages(modelInput) {
      var productId = modelInput.dataset.productId || '';
      var panel = root.querySelector('[data-model-packages="' + escapeAttr(productId) + '"]');
      var target = panel && !panel.hidden
        ? panel
        : root.querySelector('[data-step-panel="1"] .boat-builder__panel-actions');
      if (!target || typeof target.scrollIntoView !== 'function') {
        return;
      }
      var motion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      target.scrollIntoView({ behavior: motion, block: 'start' });
    }

    function setStep(step) {
      step = Math.max(1, Math.min(3, step || 1));
      if (step > 1 && !state.base) {
        step = 1;
      }
      state.step = step;

      root.querySelectorAll(selectors.stepButton).forEach(function(button) {
        button.classList.toggle('is-active', parseInt(button.dataset.stepButton, 10) === state.step);
      });

      root.querySelectorAll(selectors.stepPanel).forEach(function(panel) {
        panel.classList.toggle('is-active', parseInt(panel.dataset.stepPanel, 10) === state.step);
      });

      var summaryReserve = root.querySelector('[data-summary-reserve]');
      if (summaryReserve) {
        summaryReserve.hidden = state.step === 3;
      }
    }

    function handleOptionChange(input) {
      var group = groupsById[input.dataset.groupId || ''];

      if (group && group.selectionMode === 'single') {
        group.options.forEach(function(sku) {
          var sel = state.selections[sku];
          if (sel && sel.origin !== 'auto') {
            delete state.selections[sku];
          }
        });
        if (!input.dataset.emptyOption && input.checked) {
          setUserQty(input.dataset.sku, 1);
        }
        return;
      }

      if (input.dataset.emptyOption) {
        return;
      }

      setUserQty(input.dataset.sku, input.checked ? 1 : 0);
    }

    function setUserQty(sku, qty) {
      if (!sku) {
        return;
      }

      if (qty > 0) {
        state.selections[sku] = { qty: qty, origin: 'user' };
      } else {
        delete state.selections[sku];
      }
    }

    function includedQtyOf(sku) {
      return state.includedQty[sku] || 0;
    }

    // The package baseline: which options (and how many) this package bundles.
    // Used for the allowance pricing budget, the "included" tag, and the initial
    // preselection. Recomputed every update; it does NOT force selections.
    function computeIncludedBaseline() {
      var next = {};
      if (config && state.base) {
        var skus = config.packages[state.base.id] || [];
        skus.forEach(function(sku) {
          if (!sku || !config.options[sku]) {
            if (sku && !warnedLimits['pkg:' + sku]) {
              warnedLimits['pkg:' + sku] = true;
              console.warn('boat-builder: package includes SKU "' + sku + '" but no builder option matches it');
            }
            return;
          }
          next[sku] = (next[sku] || 0) + 1;
        });
      }
      state.includedQty = next;
    }

    // Runs only when the selected package changes: clears the previous package's
    // untouched preselections and preselects this package's included items. After
    // this, included items are ordinary editable selections (user can swap/remove).
    function seedPackageSelections() {
      Object.keys(state.selections).forEach(function(sku) {
        if (state.selections[sku].origin === 'included') {
          delete state.selections[sku];
        }
      });

      Object.keys(state.includedQty).forEach(function(sku) {
        var sel = state.selections[sku];
        if (!sel) {
          state.selections[sku] = { qty: state.includedQty[sku], origin: 'included' };
        } else if (sel.qty < state.includedQty[sku]) {
          sel.qty = state.includedQty[sku];
        }
      });
    }

    function applyTexasAuto() {
      if (!config) {
        return;
      }

      config.groups.forEach(function(group) {
        if (!group.texasGroup || !group.autoSelectWhenTexas) {
          return;
        }

        group.options.forEach(function(sku) {
          var option = config.options[sku];
          if (!option || !option.available) {
            return;
          }
          if (!state.selections[sku]) {
            state.selections[sku] = { qty: 1, origin: 'default' };
          }
        });
      });
    }

    function updateState() {
      var toggle = root.querySelector(selectors.texasToggle);
      var texasNow = Boolean(toggle && toggle.checked);
      if (texasNow && !state.texas) {
        applyTexasAuto();
      }
      state.texas = texasNow;

      state.base = getSelectedBase();
      state.boatProductId = state.base ? state.base.productId : '';

      computeIncludedBaseline();
      var packageId = state.base ? state.base.id : '';
      if (config && packageId !== state.includedPackageId) {
        seedPackageSelections();
        state.includedPackageId = packageId;
      }
      runRulesEngine();

      state.options = collectSelectedOptions();

      var subtotal = state.base ? state.base.price : 0;
      state.options.forEach(function(option) {
        subtotal += option.chargedAmount;
      });
      state.credits.forEach(function(credit) {
        subtotal -= credit.amount;
      });
      if (subtotal < 0) {
        console.warn('boat-builder: package credits exceeded the build subtotal; flooring at 0');
        subtotal = 0;
      }

      var waters = root.querySelector(selectors.publicWaters);
      state.publicWaters = Boolean(waters && waters.checked);

      var watersRow = root.querySelector('[data-public-waters-row]');
      if (watersRow) {
        watersRow.hidden = !state.texas;
      }

      state.subtotal = subtotal;
      state.tax = state.texas ? Math.round(subtotal * (taxRate / 100)) : 0;
      state.fees = computeTexasFees();
      state.feesTotal = state.fees.reduce(function(sum, fee) { return sum + fee.amount; }, 0);
      state.total = subtotal + state.tax + state.feesTotal;

      syncDom();
      renderSummary();
      maybeFetchShippingEstimate(false);
    }

    // Flat Texas title/registration fees. Government fees, so they sit outside
    // the taxable subtotal — added straight to the total when their trigger is met.
    function computeTexasFees() {
      if (!state.texas) {
        return [];
      }
      var fees = [];
      if (state.base && texasFees.boat.amount > 0) {
        fees.push({ key: 'boat', label: texasFees.boat.label, amount: texasFees.boat.amount });
      }
      if (texasFees.trailer.amount > 0 && groupHasSelection(texasFees.trailer.group)) {
        fees.push({ key: 'trailer', label: texasFees.trailer.label, amount: texasFees.trailer.amount });
      }
      if (texasFees.outboard.amount > 0 && groupHasSelection(texasFees.outboard.group)) {
        fees.push({ key: 'outboard', label: texasFees.outboard.label, amount: texasFees.outboard.amount });
      }
      if (state.publicWaters && texasFees.publicWaters.amount > 0) {
        fees.push({ key: 'public-waters', label: texasFees.publicWaters.label, amount: texasFees.publicWaters.amount });
      }
      return fees;
    }

    function groupHasSelection(groupId) {
      if (!groupId) {
        return false;
      }
      return state.options.some(function(option) {
        return option.groupId === groupId && option.quantity > 0;
      });
    }

    function runRulesEngine() {
      if (!config) {
        return;
      }

      view = {};
      Object.keys(config.options).forEach(function(sku) {
        view[sku] = { visible: false, locked: false, max: null, groupAtCap: false };
      });

      // Sweep out selections this boat can never offer BEFORE any pool math.
      // The loop below would delete them anyway (line with !visible), but only
      // when their own iteration slot is reached — and a stale selection from
      // a previous boat (e.g. a 2-slot bench not sold on this one) processed
      // later than a surviving seat would inflate the pool's "used" during the
      // first pass and wrongly trim seats that do fit. showIf/Texas visibility
      // still resolves iteratively inside the loop.
      Object.keys(state.selections).forEach(function(sku) {
        var option = config.options[sku];
        if (!option || !option.available || option.boats.indexOf(state.boatProductId) === -1) {
          delete state.selections[sku];
        }
      });

      var converged = false;
      for (var pass = 0; pass < 10 && !converged; pass++) {
        var changed = false;

        config.groups.forEach(function(group) {
          var texasOk = !group.texasGroup || state.texas;

          group.options.forEach(function(sku) {
            var option = config.options[sku];
            var entry = view[sku];
            if (!option || !entry) {
              return;
            }

            var visible = texasOk && option.boats.indexOf(state.boatProductId) !== -1;
            if (visible && option.showIf) {
              visible = evaluateCondition(option.showIf);
            }
            if (visible !== entry.visible) {
              entry.visible = visible;
              changed = true;
            }
            if ((!visible || !option.available) && qtyOf(sku) > 0) {
              delete state.selections[sku];
              changed = true;
            }

            var max = effectiveMax(option);
            var locked = false;
            if (option.requiredIf && visible && option.available) {
              locked = evaluateCondition(option.requiredIf);
            }
            if (locked && max !== null && max < 1) {
              locked = false;
              var lockWarnKey = 'lock:' + sku;
              if (!warnedLimits[lockWarnKey]) {
                warnedLimits[lockWarnKey] = true;
                console.warn('boat-builder: required option "' + sku + '" has a quantity cap of 0; the requirement was not applied');
              }
            }
            if (locked && qtyOf(sku) < 1) {
              state.selections[sku] = { qty: 1, origin: 'auto' };
              changed = true;
            }
            if (!locked && state.selections[sku] && state.selections[sku].origin === 'auto') {
              delete state.selections[sku];
              changed = true;
            }
            if (locked !== entry.locked) {
              entry.locked = locked;
              changed = true;
            }

            entry.max = max;
            var floorQty = includedQtyOf(sku);
            if (max !== null && qtyOf(sku) > Math.max(max, floorQty)) {
              var target = Math.max(max, floorQty);
              if (target > 0) {
                state.selections[sku].qty = target;
              } else {
                delete state.selections[sku];
              }
              changed = true;
            }
          });

          if (group.selectionMode === 'single') {
            var lockedSelected = group.options.some(function(sku) {
              return view[sku] && view[sku].locked && qtyOf(sku) > 0;
            });
            if (lockedSelected) {
              group.options.forEach(function(sku) {
                var sel = state.selections[sku];
                if (sel && sel.origin !== 'auto') {
                  delete state.selections[sku];
                  changed = true;
                }
              });
            }
          }

          // Group selection cap (e.g. up to 2 trolling motors, only 1 outboard).
          // Counts quantities across the visible options in the group; trims the
          // newest user-picked selections back to the cap and flags the rest so
          // the UI disables adding more.
          if (group.maxSelections && group.maxSelections > 0) {
            var cap = group.maxSelections;
            var capMembers = group.options.filter(function(sku) {
              return view[sku] && view[sku].visible;
            });
            var capUsed = 0;
            capMembers.forEach(function(sku) {
              capUsed += qtyOf(sku);
            });
            for (var ci = capMembers.length - 1; ci >= 0 && capUsed > cap; ci--) {
              var capSku = capMembers[ci];
              var capSel = state.selections[capSku];
              if (!capSel || capSel.origin === 'auto') {
                continue;
              }
              var drop = Math.min(capSel.qty, capUsed - cap);
              if (capSel.qty - drop > 0) {
                capSel.qty -= drop;
              } else {
                delete state.selections[capSku];
              }
              capUsed -= drop;
              changed = true;
            }
            capMembers.forEach(function(sku) {
              view[sku].groupAtCap = capUsed >= cap && qtyOf(sku) === 0;
            });
          }
        });

        converged = !changed;
      }

      if (!converged) {
        console.warn('boat-builder: rules did not converge after 10 passes; check the metaobject rules for circular references');
      }
    }

    function evaluateCondition(condition) {
      if (!condition) {
        return true;
      }

      if (condition.anySelected) {
        return condition.anySelected.some(function(sku) {
          return qtyOf(sku) > 0;
        });
      }

      if (condition.noneSelected) {
        return !condition.noneSelected.some(function(sku) {
          return qtyOf(sku) > 0;
        });
      }

      if (condition.countAtLeast) {
        return sumQty(condition.countAtLeast.skus) >= condition.countAtLeast.min;
      }

      if (condition.all) {
        return condition.all.every(evaluateCondition);
      }

      if (condition.any) {
        return condition.any.some(evaluateCondition);
      }

      return true;
    }

    function effectiveMax(option) {
      var base = baseMax(option);
      // Per-boat cap override tightens (never loosens) the computed max, e.g.
      // Below-Deck Battery Box = 1 on Champ but 2 on Ultra/Elite.
      var override = boatMaxOverride(option.sku);
      if (override === null) {
        return base;
      }
      if (base === null || base === undefined) {
        return override;
      }
      return Math.min(base, override);
    }

    function baseMax(option) {
      var isQuantity = option.selectorType === 'quantity';
      var mode = option.maxQtyMode || 'fixed';

      // Pool math runs for members of any selector type: a checkbox option in
      // the pool still must not fit when fewer slots remain than it occupies.
      if (mode === 'boat_limit' && option.poolKey) {
        var cap = boatLimit(option.poolKey, false);
        if (cap !== null) {
          var used = 0;
          (poolMembers[option.poolKey] || []).forEach(function(member) {
            if (member !== option.sku) {
              used += qtyOf(member) * slotWeightOf(config.options[member]);
            }
          });
          // Remaining slots → how many units of THIS option fit (a 2-slot
          // bench fits once in 3 free holes), further capped by its own fixed
          // max when set (only 1 bench per boat regardless of free holes).
          var maxUnits = Math.floor(Math.max(0, cap - used) / slotWeightOf(option));
          if (option.maxQty != null) {
            maxUnits = Math.min(maxUnits, option.maxQty);
          }
          return isQuantity ? maxUnits : Math.min(1, maxUnits);
        }
      }

      if (!isQuantity) {
        return 1;
      }

      if (mode === 'dynamic_count') {
        // Max = how many seats are currently selected (across all counted seat
        // types). Lets a 1 AW + 2 ProBax build accept up to 3 armrests.
        // Deliberately item-based, never slot-weighted — and the 2-slot bench
        // sits in no count list at all (built-in armrests, dedicated cover).
        return sumQty(option.countSkus);
      }

      return option.maxQty != null ? option.maxQty : null;
    }

    // Per-boat max override for a SKU (from boat_builder.max_qty_overrides JSON).
    function boatMaxOverride(sku) {
      if (!config || !config.boats) {
        return null;
      }
      var boat = config.boats[state.boatProductId];
      var overrides = boat && boat.max_qty_overrides;
      if (!overrides) {
        return null;
      }
      var value = overrides[sku];
      return (typeof value === 'number' && value >= 0) ? value : null;
    }

    function boatLimit(key, silent) {
      if (!key || !config || !config.boats) {
        return null;
      }

      var boat = config.boats[state.boatProductId];
      if (!boat) {
        return null;
      }

      var value = boat[key];
      if (value === null || value === undefined) {
        var warnKey = state.boatProductId + ':' + key;
        if (!silent && !warnedLimits[warnKey]) {
          warnedLimits[warnKey] = true;
          console.warn('boat-builder: boat product ' + state.boatProductId + ' has no boat_builder.' + key + ' metafield; treating the limit as uncapped');
        }
        return null;
      }

      return value;
    }

    function qtyOf(sku) {
      var sel = state.selections[sku];
      return sel ? sel.qty : 0;
    }

    // How many pool slots one unit of this option occupies (a 55" bench fills
    // 2 seat holes). Blank/invalid metaobject values mean 1.
    function slotWeightOf(option) {
      if (!option) {
        return 1;
      }
      var weight = parseInt(option.slotWeight, 10);
      return weight > 1 ? weight : 1;
    }

    function sumQty(skus) {
      var total = 0;
      (skus || []).forEach(function(sku) {
        total += qtyOf(sku);
      });
      return total;
    }

    function collectSelectedOptions() {
      state.credits = [];
      if (!config) {
        return [];
      }

      var options = [];

      config.groups.forEach(function(group) {
        group.options.forEach(function(sku) {
          var qty = qtyOf(sku);
          if (!qty) {
            return;
          }
          var option = config.options[sku];
          if (!option) {
            return;
          }
          var sel = state.selections[sku];

          options.push({
            id: option.variantId,
            title: option.title,
            productTitle: option.productTitle,
            sku: sku,
            groupId: group.id,
            groupTitle: group.title,
            price: option.price,
            quantity: qty,
            includedBaseline: includedQtyOf(sku),
            fullAmount: option.price * qty,
            chargedAmount: option.price * qty,
            creditApplied: 0,
            texasFee: Boolean(group.texasGroup),
            required: sel.origin === 'auto'
          });
        });
      });

      state.credits = applyAllowancePricing(options);
      return options;
    }

    // Per-group allowance pricing. Each group's budget = the value of the options
    // the package includes in that group. Selected options draw down that budget,
    // package-included items first so they stay free, so a swap charges only the
    // difference. Any budget left after the selected items are covered (because the
    // customer removed or downgraded an included item) is returned as a per-group
    // credit, so removing the package motor refunds its value. Returns the credit
    // lines; annotates each option's chargedAmount/creditApplied in place.
    function applyAllowancePricing(options) {
      var credits = [];
      config.groups.forEach(function(group) {
        var allowance = 0;
        group.options.forEach(function(sku) {
          var opt = config.options[sku];
          var entry = view[sku];
          // Only count budget for included items the customer can actually see and
          // remove on this boat — otherwise an unavailable bundled SKU would mint a
          // phantom credit the customer can never cancel.
          if (opt && entry && entry.visible && opt.available) {
            allowance += opt.price * includedQtyOf(sku);
          }
        });
        if (allowance <= 0) {
          return;
        }

        var inGroup = options.filter(function(o) { return o.groupId === group.id; });
        var ordered = inGroup.filter(function(o) { return o.includedBaseline > 0; })
          .concat(inGroup.filter(function(o) { return o.includedBaseline === 0; }));

        var remaining = allowance;
        ordered.forEach(function(o) {
          var credit = Math.min(remaining, o.fullAmount);
          remaining -= credit;
          o.creditApplied = credit;
          o.chargedAmount = o.fullAmount - credit;
        });

        if (remaining > 0) {
          credits.push({ groupId: group.id, groupTitle: group.title, amount: remaining });
        }
      });
      return credits;
    }

    // Standard-equipment lines for the selected package, or undefined when the
    // variant has none — JSON.stringify then drops the key, so payloads for
    // boats without a list stay exactly as they were.
    function standardEquipmentForBase() {
      var items = (config && state.base && config.standardEquipment)
        ? config.standardEquipment[state.base.id]
        : null;
      return (items && items.length) ? items.slice() : undefined;
    }

    // Read-only "Standard equipment included" list for the selected package.
    function renderStandardEquipment() {
      var wrap = root.querySelector('[data-standard-equipment]');
      if (!wrap) {
        return;
      }
      var listEl = wrap.querySelector('[data-standard-list]');
      var items = standardEquipmentForBase();
      if (!items || !items.length) {
        wrap.hidden = true;
        if (listEl) {
          listEl.innerHTML = '';
        }
        return;
      }
      if (listEl) {
        listEl.innerHTML = '';
        items.forEach(function(text) {
          var li = document.createElement('li');
          li.textContent = text;
          listEl.appendChild(li);
        });
      }
      wrap.hidden = false;
    }

    // The seat group is whichever group owns the max_seats_total pool — found by
    // data, so a rename of the group's handle/title doesn't break the note.
    function seatGroupId() {
      if (!config) {
        return null;
      }
      for (var i = 0; i < config.groups.length; i++) {
        var group = config.groups[i];
        for (var j = 0; j < group.options.length; j++) {
          var option = config.options[group.options[j]];
          if (option && option.poolKey === 'max_seats_total') {
            return group.id;
          }
        }
      }
      return null;
    }

    // Per-boat, merchant-authored note at the top of the seat section.
    function renderSeatNote() {
      var groupId = seatGroupId();
      if (!groupId) {
        return;
      }
      var groupEl = root.querySelector('[data-option-group][data-group-id="' + escapeAttr(groupId) + '"]');
      var noteEl = groupEl ? groupEl.querySelector('[data-group-note]') : null;
      if (!noteEl) {
        return;
      }
      var boat = (config.boats && state.base) ? config.boats[state.base.productId] : null;
      var text = boat && boat.seats_note ? String(boat.seats_note).trim() : '';
      if (text) {
        noteEl.textContent = text;
        noteEl.hidden = false;
      } else {
        noteEl.textContent = '';
        noteEl.hidden = true;
      }
    }

    function syncDom() {
      updateBoatCards();
      renderStandardEquipment();
      renderSeatNote();

      var goStep2 = root.querySelector('[data-step-panel="1"] [data-go-step="2"]');
      if (goStep2) {
        goStep2.disabled = !state.base;
      }

      // Summary-card shortcut to the reserve step: needs a boat picked, and is
      // hidden once you're already on step 3 (where it would be redundant).
      var summaryReserve = root.querySelector('[data-summary-reserve]');
      if (summaryReserve) {
        summaryReserve.disabled = !state.base;
        summaryReserve.hidden = state.step === 3;
      }

      if (!config) {
        return;
      }

      config.groups.forEach(function(group) {
        var groupEl = root.querySelector('[data-option-group][data-group-id="' + escapeAttr(group.id) + '"]');
        var anyVisible = false;
        var anySelectedVisible = false;

        group.options.forEach(function(sku) {
          var entry = view[sku];
          var option = config.options[sku];
          if (!entry || !option) {
            return;
          }

          var card = root.querySelector('[data-option-card="' + escapeAttr(sku) + '"]');
          if (!card) {
            return;
          }

          var qty = qtyOf(sku);
          card.hidden = !entry.visible;
          if (entry.visible) {
            anyVisible = true;
            if (qty > 0) {
              anySelectedVisible = true;
            }
          }

          var includedHere = includedQtyOf(sku);

          // An unselected option whose max dropped to 0 (pool full, or fewer
          // free slots than its slot weight) can't be added — disable it
          // instead of letting the click be silently reverted by the engine.
          // Included items stay addable up to their package floor even on a
          // full pool (same ceiling the engine clamp and +/- buttons use).
          var atMaxZero = entry.max !== null && entry.max !== undefined &&
            Math.max(entry.max, includedHere) < 1 && qty === 0;

          var choiceInput = card.querySelector(selectors.optionInput);
          if (choiceInput) {
            choiceInput.checked = qty > 0;
            choiceInput.disabled = !option.available || entry.locked || entry.groupAtCap || atMaxZero;
          }

          var quantityInput = card.querySelector(selectors.optionQuantity);
          if (quantityInput) {
            if (parseInt(quantityInput.value || '0', 10) !== qty) {
              quantityInput.value = qty;
            }
            var displayMax = (entry.max !== null && entry.max !== undefined) ? Math.max(entry.max, includedHere) : null;
            if (displayMax !== null) {
              quantityInput.max = displayMax;
            } else {
              quantityInput.removeAttribute('max');
            }
            var plusButton = card.querySelector('[data-quantity-plus]');
            if (plusButton) {
              plusButton.disabled = (displayMax !== null && qty >= displayMax) || entry.groupAtCap;
            }
            var minusButton = card.querySelector('[data-quantity-minus]');
            if (minusButton) {
              minusButton.disabled = qty <= 0;
            }
          }

          var requiredTag = card.querySelector('[data-required-tag]');
          if (requiredTag) {
            requiredTag.hidden = !entry.locked;
          }

          // Informational tag: this item came with the package (still editable).
          // Shows the included count so "2 of your seats are free" is explicit.
          // The count is what's actually free in THIS build (min of qty and
          // baseline — same formula as the summary/contact payload), and it is
          // spelled out whenever the selected qty exceeds it, so "1 included"
          // next to qty 3 never reads as "all 3 are free".
          var includedTag = card.querySelector('[data-included-tag]');
          if (includedTag) {
            var showIncludedTag = includedHere > 0 && qty > 0;
            includedTag.hidden = !showIncludedTag;
            if (showIncludedTag) {
              var includedShown = Math.min(qty, includedHere);
              includedTag.textContent = (includedShown > 1 || qty > includedShown)
                ? includedShown + ' included with this package'
                : 'Included with this package';
            }
          }

          card.classList.toggle('is-locked', entry.locked);
          card.classList.toggle('is-included', includedHere > 0 && qty > 0);
          card.classList.toggle('is-selected', qty > 0);
          card.classList.toggle('is-at-cap', (Boolean(entry.groupAtCap) || atMaxZero) && qty === 0);
        });

        if (groupEl) {
          groupEl.hidden = !anyVisible;

          updateGroupAvailability(groupEl, group, anyVisible);

          if (group.selectionMode === 'single') {
            var emptyInput = groupEl.querySelector('[data-empty-option]');
            if (emptyInput) {
              emptyInput.checked = !anySelectedVisible;
              var emptyCard = emptyInput.closest('.boat-builder__option-card');
              if (emptyCard) {
                emptyCard.classList.toggle('is-selected', !anySelectedVisible);
              }
            }
          }
        }
      });
    }

    // "Add up to N more" pill in a group heading. Two cap sources:
    //  - group.maxSelections: a fixed per-group selection cap (motors).
    //  - a shared boat pool (seats → max_seats_total, batteries → max_batteries):
    //    cap is the boat's metafield, usage sums the whole pool.
    function updateGroupAvailability(groupEl, group, anyVisible) {
      var el = groupEl.querySelector('[data-group-availability]');
      if (!el) {
        return;
      }

      var cap = null;
      var used = 0;

      if (group.maxSelections && group.maxSelections > 0) {
        cap = group.maxSelections;
        group.options.forEach(function(sku) {
          if (view[sku] && view[sku].visible) {
            used += qtyOf(sku);
          }
        });
      } else {
        var poolKey = null;
        group.options.forEach(function(sku) {
          var option = config.options[sku];
          if (option && option.poolKey && !poolKey) {
            poolKey = option.poolKey;
          }
        });
        if (poolKey) {
          cap = boatLimit(poolKey, true);
          (poolMembers[poolKey] || []).forEach(function(sku) {
            used += qtyOf(sku) * slotWeightOf(config.options[sku]);
          });
        }
      }

      // cap <= 0 means the boat offers none of this pool at all (e.g.
      // max_batteries = 0) — "Limit reached" would falsely imply the customer
      // consumed an allowance, so show no pill.
      if (cap === null || cap === undefined || cap <= 0 || !anyVisible) {
        el.hidden = true;
        el.textContent = '';
        el.classList.remove('is-full');
        return;
      }

      var remaining = Math.max(0, cap - used);
      el.hidden = false;
      if (remaining <= 0) {
        el.textContent = 'Limit reached';
      } else if (used > 0) {
        el.textContent = 'Add up to ' + remaining + ' more';
      } else {
        el.textContent = 'Choose up to ' + cap;
      }
      el.classList.toggle('is-full', remaining <= 0);
    }

    function updateBoatCards() {
      root.querySelectorAll('.boat-builder__boat-card').forEach(function(card) {
        var input = card.querySelector('input');
        card.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    }

    function escapeAttr(value) {
      return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function markReady() {
      var wrap = root.querySelector('[data-option-groups]');
      if (wrap) {
        wrap.classList.remove('is-loading');
        wrap.classList.add('is-ready');
      }
    }

    function getSelectedBase() {
      var input = root.querySelector(selectors.baseInput + ':checked:not(:disabled)');
      if (!input) {
        return null;
      }

      return {
        id: input.dataset.id,
        title: input.dataset.title || '',
        productTitle: input.dataset.productTitle || '',
        productId: input.dataset.productId || '',
        sku: input.dataset.sku || '',
        price: parseInt(input.dataset.price || '0', 10),
        quantity: 1
      };
    }

    function renderSummary() {
      var baseEl = root.querySelector('[data-summary-base]');
      var optionsEl = root.querySelector('[data-summary-options]');
      var subtotalEl = root.querySelector('[data-summary-subtotal]');
      var taxEl = root.querySelector('[data-summary-tax]');
      var taxRow = root.querySelector('[data-tax-row]');
      var totalEl = root.querySelector('[data-summary-total]');
      var depositEl = root.querySelector('[data-summary-deposit]');

      if (baseEl) {
        baseEl.textContent = state.base ? formatBaseLabel(state.base) : 'Choose a boat';
      }

      if (optionsEl) {
        optionsEl.innerHTML = '';
        state.options.forEach(function(option) {
          var row = document.createElement('div');
          row.className = 'boat-builder__summary-option';
          row.innerHTML = '<span></span><strong></strong>';
          var labelText = (option.quantity > 1 ? option.quantity + 'x ' : '') + stripTitleMarkers(option.title);
          var priceText = formatMoney(option.chargedAmount);
          if (option.includedBaseline > 0) {
            if (option.chargedAmount === 0) {
              priceText = 'Included';
            } else {
              priceText = '+' + formatMoney(option.chargedAmount);
            }
          } else if (option.creditApplied > 0) {
            if (option.chargedAmount === 0) {
              priceText = 'Included';
            } else {
              labelText += ' (upgrade)';
              priceText = '+' + formatMoney(option.chargedAmount);
            }
          } else if (option.required) {
            labelText += ' [required]';
          }
          row.querySelector('span').textContent = labelText;
          row.querySelector('strong').textContent = priceText;
          optionsEl.appendChild(row);
        });

        state.credits.forEach(function(credit) {
          var row = document.createElement('div');
          row.className = 'boat-builder__summary-option boat-builder__summary-credit';
          row.innerHTML = '<span></span><strong></strong>';
          row.querySelector('span').textContent = credit.groupTitle + ' package credit';
          row.querySelector('strong').textContent = '-' + formatMoney(credit.amount);
          optionsEl.appendChild(row);
        });
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(state.subtotal);
      }

      if (taxEl) {
        taxEl.textContent = formatMoney(state.tax);
      }

      if (taxRow) {
        taxRow.hidden = !state.texas;
      }

      var shippingRow = root.querySelector('[data-shipping-row]');
      if (shippingRow) {
        shippingRow.hidden = state.shipping.status !== 'ready';
        if (state.shipping.status === 'ready') {
          var shippingEl = shippingRow.querySelector('[data-summary-shipping]');
          if (shippingEl) {
            shippingEl.textContent = formatMoney(state.shipping.amount);
          }
        }
      }

      var feesEl = root.querySelector('[data-summary-fees]');
      if (feesEl) {
        feesEl.innerHTML = '';
        state.fees.forEach(function(fee) {
          var row = document.createElement('div');
          row.className = 'boat-builder__fee-row';
          row.innerHTML = '<span></span><strong></strong>';
          row.querySelector('span').textContent = fee.label;
          row.querySelector('strong').textContent = formatMoney(fee.amount);
          feesEl.appendChild(row);
        });
      }

      if (totalEl) {
        totalEl.textContent = formatMoney(state.total);
      }

      if (depositEl) {
        depositEl.textContent = formatMoney(getDepositPrice());
      }
    }

    function getDepositVariantId() {
      var deposit = root.querySelector(selectors.deposit);
      return deposit ? (deposit.dataset.variantId || '') : '';
    }

    function getDepositPrice() {
      var deposit = root.querySelector(selectors.deposit);
      return deposit ? parseInt(deposit.dataset.price || '0', 10) : 0;
    }

    function getContactDetails() {
      return {
        name: getFieldValue('[data-contact-name]'),
        email: getFieldValue('[data-contact-email]'),
        phone: getFieldValue('[data-contact-phone]'),
        city: getFieldValue('[data-contact-city]'),
        zip: getFieldValue('[data-contact-zip]'),
        notes: getFieldValue('[data-contact-notes]')
      };
    }

    function getFieldValue(selector) {
      var field = root.querySelector(selector);
      return field ? field.value.trim() : '';
    }

    // ---- Freight estimate (ShipX via Storefront API) ----------------------
    // The boat never enters the real cart (checkout charges the deposit only),
    // so rates come from a throwaway Storefront-API cart holding the selected
    // package variant. Shopify forwards that cart + ZIP to the store's
    // carrier-calculated app (ShipX) and streams its rate back. Advisory only:
    // the amount is never added to state.total.

    var CART_CREATE_MUTATION =
      'mutation BoatFreightCart($lines: [CartLineInput!]!, $country: CountryCode!, $address: CartDeliveryAddressInput!) {' +
      ' cartCreate(input: {' +
      ' lines: $lines,' +
      ' buyerIdentity: { countryCode: $country },' +
      ' delivery: { addresses: [{ address: { deliveryAddress: $address }, selected: true, oneTimeUse: true }] }' +
      ' }) { cart { id } userErrors { field message } }' +
      '}';

    // @defer is required for withCarrierRates and only works on queries, so
    // rates always take a second request after cartCreate.
    var CART_RATES_QUERY =
      'query BoatFreightRates($cartId: ID!) {' +
      ' cart(id: $cartId) { id ...DeferredRates @defer }' +
      '}' +
      ' fragment DeferredRates on Cart {' +
      ' deliveryGroups(first: 10, withCarrierRates: true) {' +
      ' edges { node { deliveryOptions {' +
      ' handle title code deliveryMethodType estimatedCost { amount currencyCode }' +
      ' } } }' +
      ' }' +
      '}';

    // US state by 3-digit ZIP prefix range. Carrier rate requests are more
    // reliable with a province set; military (090-099, 340, 962-966) and
    // territory (006-009, 969) prefixes are left blank on purpose — Shopify
    // treats those as separate countries.
    var US_ZIP_PREFIX_STATES = [
      [5, 5, 'NY'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'],
      [39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'],
      [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'], [200, 200, 'DC'],
      [201, 201, 'VA'], [202, 205, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'],
      [247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'],
      [320, 339, 'FL'], [341, 349, 'FL'], [350, 369, 'AL'], [370, 385, 'TN'],
      [386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'], [430, 459, 'OH'],
      [460, 479, 'IN'], [480, 499, 'MI'], [500, 528, 'IA'], [530, 549, 'WI'],
      [550, 567, 'MN'], [570, 577, 'SD'], [580, 588, 'ND'], [590, 599, 'MT'],
      [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'], [680, 693, 'NE'],
      [700, 714, 'LA'], [716, 729, 'AR'], [730, 732, 'OK'], [733, 733, 'TX'],
      [734, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'],
      [832, 838, 'ID'], [840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'],
      [885, 885, 'TX'], [889, 898, 'NV'], [900, 961, 'CA'], [967, 968, 'HI'],
      [970, 979, 'OR'], [980, 994, 'WA'], [995, 999, 'AK']
    ];

    function usStateForZip(zip) {
      var prefix = parseInt(zip.slice(0, 3), 10);
      for (var i = 0; i < US_ZIP_PREFIX_STATES.length; i++) {
        if (prefix >= US_ZIP_PREFIX_STATES[i][0] && prefix <= US_ZIP_PREFIX_STATES[i][1]) {
          return US_ZIP_PREFIX_STATES[i][2];
        }
      }
      return '';
    }

    function buildEstimateAddress(zip, city) {
      var address = { zip: zip, countryCode: shippingCfg.country };
      // Carriers that rate on city + ZIP need the city present; an empty
      // string is not the same as an absent field to Shopify, so omit it
      // rather than sending city: '' (same rule as provinceCode below).
      if (city) {
        address.city = city;
      }
      if (shippingCfg.country === 'US') {
        var provinceCode = usStateForZip(zip);
        if (provinceCode) {
          address.provinceCode = provinceCode;
        }
      }
      return address;
    }

    // Collapse whitespace for what we send; compare and cache case-insensitively
    // so re-capitalising "dallas" doesn't throw away a good estimate.
    function normalizeCity(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    // Invalidates any in-flight estimate so its late response can't land:
    // every settled shipping state must be preceded by this or carry the
    // current seq itself.
    function cancelShippingFetch() {
      shippingSeq += 1;
      if (shippingAbort) {
        shippingAbort.abort();
        shippingAbort = null;
      }
    }

    function maybeFetchShippingEstimate(force) {
      if (!shippingCfg.enabled) {
        return;
      }
      var match = getFieldValue('[data-contact-zip]').match(/^(\d{5})(?:-\d{4})?$/);
      var zip = match ? match[1] : '';
      // City is required to quote, not optional. Verified against the live
      // rate apps: LTL boats (Patriot Mini — ShipperHQ/SAIA) return NO RATES
      // for a ZIP with no city, and the mileage-rated boats return the same
      // amount either way. So a ZIP-only request can only produce a wrong
      // "we could not estimate freight to this ZIP" for LTL, and never adds
      // anything for the rest. Waiting for the city costs nothing.
      var city = normalizeCity(getFieldValue('[data-contact-city]'));
      var variantId = state.base ? String(state.base.id) : '';
      if (!zip || !city || !variantId) {
        if (state.shipping.status !== 'idle') {
          cancelShippingFetch();
          setShipping({ status: 'idle', amount: null, title: '', zip: '', city: '', variantId: '' });
        }
        return;
      }
      if (state.shipping.zip === zip &&
          sameCity(state.shipping.city, city) &&
          state.shipping.variantId === variantId) {
        if (state.shipping.status === 'ready' || state.shipping.status === 'loading') {
          return; // already showing (or fetching) this exact answer
        }
        if (state.shipping.status === 'unavailable' && !force) {
          return; // settled no-rate answer; blur retries it
        }
        if (state.shipping.status === 'error' && !force && Date.now() - shippingErrorAt < 30000) {
          return; // don't hammer the API from updateState() after a failure
        }
      }
      var cached = shippingCache[cacheKey(variantId, zip, city)];
      if (cached && !(force && cached.status === 'unavailable')) {
        cancelShippingFetch();
        setShipping(cached);
        return;
      }
      fetchShippingEstimate(zip, city, variantId);
    }

    function cacheKey(variantId, zip, city) {
      return variantId + ':' + zip + ':' + city.toLowerCase();
    }

    function sameCity(a, b) {
      return String(a || '').toLowerCase() === String(b || '').toLowerCase();
    }

    function fetchShippingEstimate(zip, city, variantId) {
      cancelShippingFetch();
      var seq = shippingSeq;
      var controller = window.AbortController ? new AbortController() : null;
      shippingAbort = controller;
      // Shopify gives carrier apps ~10s to answer; abort a little after that.
      // Without AbortController the request can't be cancelled, so settle the
      // UI to 'error' and let the seq guard swallow whatever arrives later.
      var timer = setTimeout(function() {
        if (controller) {
          controller.abort();
          return;
        }
        if (seq !== shippingSeq) {
          return;
        }
        shippingSeq += 1;
        shippingErrorAt = Date.now();
        setShipping({ status: 'error', amount: null, title: '', zip: zip, city: city, variantId: variantId });
      }, 15000);

      setShipping({ status: 'loading', amount: null, title: '', zip: zip, city: city, variantId: variantId });

      storefrontFetch(CART_CREATE_MUTATION, {
        lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }],
        country: shippingCfg.country,
        address: buildEstimateAddress(zip, city)
      }, controller, false)
        .then(function(payload) {
          var result = payload && payload.data && payload.data.cartCreate;
          var errors = (result && result.userErrors) || [];
          if (!result || !result.cart || errors.length) {
            throw new Error(errors.length ? errors[0].message : 'cartCreate returned no cart');
          }
          return storefrontFetch(CART_RATES_QUERY, { cartId: result.cart.id }, controller, true);
        })
        .then(function(text) {
          clearTimeout(timer);
          if (seq !== shippingSeq) {
            return; // superseded by a newer request
          }
          var payloads = parseMultipartGraphQL(text);
          var best = cheapestShippingOption(extractDeliveryOptions(payloads));
          if (!best) {
            var rateErrors = extractRateErrors(payloads);
            if (rateErrors.length) {
              // Throw into the catch below: sets the 30s cooldown and leaves
              // the result uncached, so a later attempt can still get a rate.
              throw new Error(rateErrors[0].message || 'carrier rates unavailable');
            }
          }
          var next = best
            ? { status: 'ready', amount: best.amount, title: best.title, zip: zip, city: city, variantId: variantId }
            : { status: 'unavailable', amount: null, title: '', zip: zip, city: city, variantId: variantId };
          shippingCache[cacheKey(variantId, zip, city)] = next;
          setShipping(next);
        })
        .catch(function(err) {
          clearTimeout(timer);
          if (seq !== shippingSeq) {
            return;
          }
          shippingErrorAt = Date.now();
          console.warn('boat-builder: freight estimate failed', err);
          setShipping({ status: 'error', amount: null, title: '', zip: zip, city: city, variantId: variantId });
        });
    }

    function storefrontFetch(query, variables, controller, wantsDeferred) {
      return fetch('/api/' + shippingCfg.apiVersion + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': wantsDeferred ? 'multipart/mixed; deferSpec=20220824, application/json' : 'application/json',
          'X-Shopify-Storefront-Access-Token': shippingCfg.token
        },
        body: JSON.stringify({ query: query, variables: variables }),
        signal: controller ? controller.signal : undefined
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Storefront API HTTP ' + response.status);
        }
        // text() resolves once the stream — including the deferred part — ends.
        return wantsDeferred ? response.text() : response.json();
      });
    }

    // Deferred responses arrive as multipart/mixed with boundary "graphql":
    // each part is MIME headers, a blank line, and a JSON payload. Raw
    // newlines never appear inside the JSON (strings escape them), so
    // splitting on boundary lines is safe. A plain JSON body (nothing
    // deferred) falls out of the same code as a single part.
    function parseMultipartGraphQL(text) {
      var payloads = [];
      String(text).split(/(?:^|\r?\n)--[^\r\n]*(?:\r?\n|$)/).forEach(function(part) {
        var start = part.indexOf('{');
        if (start === -1) {
          return;
        }
        try {
          payloads.push(JSON.parse(part.slice(start)));
        } catch (err) {
          // headers-only or truncated part — not a payload
        }
      });
      return payloads;
    }

    // A deferred payload can carry errors in place of rates. The one that
    // matters is THROTTLED — "Carrier-calculated rates through @defer is
    // temporarily unavailable" — which Shopify returns shop-wide once too many
    // carrier requests have been made in a window. It means "ask again later",
    // NOT "there is no rate for this address", so it must never settle as
    // 'unavailable': that answer gets cached and the customer is told freight
    // could not be estimated for a ZIP that rates perfectly well.
    function extractRateErrors(payloads) {
      var errors = [];
      payloads.forEach(function(payload) {
        (payload.errors || []).forEach(function(err) {
          errors.push(err);
        });
        (payload.incremental || []).forEach(function(part) {
          (part.errors || []).forEach(function(err) {
            errors.push(err);
          });
        });
      });
      return errors;
    }

    // The initial payload carries data.cart (rates pending); the deferred one
    // carries incremental[].data.deliveryGroups with path ["cart"].
    function extractDeliveryOptions(payloads) {
      var options = [];
      function collect(data) {
        var groups = data && (data.deliveryGroups || (data.cart && data.cart.deliveryGroups));
        if (!groups || !groups.edges) {
          return;
        }
        groups.edges.forEach(function(edge) {
          var list = (edge.node && edge.node.deliveryOptions) || [];
          list.forEach(function(option) {
            options.push(option);
          });
        });
      }
      payloads.forEach(function(payload) {
        collect(payload.data);
        (payload.incremental || []).forEach(function(part) {
          collect(part.data);
        });
      });
      return options;
    }

    // Cheapest real shipping option wins; pickup/local options are skipped.
    function cheapestShippingOption(options) {
      var best = null;
      options.forEach(function(option) {
        if (option.deliveryMethodType && option.deliveryMethodType !== 'SHIPPING') {
          return;
        }
        var cents = Math.round(parseFloat(option.estimatedCost && option.estimatedCost.amount) * 100);
        if (isNaN(cents)) {
          return;
        }
        if (!best || cents < best.amount) {
          best = { amount: cents, title: option.title || '' };
        }
      });
      return best;
    }

    function setShipping(next) {
      state.shipping = next;
      renderShippingHint();
      renderSummary();
    }

    // The estimate that may ride along with the deposit: only a settled rate
    // whose city AND ZIP still match what the customer typed AND whose variant
    // is still the selected package (guards edits and response races right
    // before "Place deposit" — when in doubt, drop the advisory estimate).
    // City is checked because it is rated: without this, correcting Dallas to
    // Houston on the same ZIP would send the Dallas rate to the order.
    function shippingEstimateForBuild(contact) {
      if (state.shipping.status !== 'ready') {
        return null;
      }
      if (!state.base || String(state.base.id) !== state.shipping.variantId) {
        return null;
      }
      var zipMatch = String(contact.zip || '').match(/^(\d{5})/);
      if (!zipMatch || zipMatch[1] !== state.shipping.zip) {
        return null;
      }
      if (!sameCity(normalizeCity(contact.city), state.shipping.city)) {
        return null;
      }
      return state.shipping;
    }

    function renderShippingHint() {
      var hint = root.querySelector('[data-shipping-hint]');
      if (!hint) {
        return;
      }
      var shipping = state.shipping;
      if (shipping.status === 'loading') {
        hint.textContent = 'Checking freight to ' + shipping.zip + '…';
        hint.hidden = false;
      } else if (shipping.status === 'ready') {
        hint.textContent = 'Estimated freight to ' + shipping.zip + ': ' + formatMoney(shipping.amount) +
          (shipping.title ? ' (' + shipping.title + ')' : '') +
          ' — quoted at final invoicing, not part of today’s deposit.';
        hint.hidden = false;
      } else if ((shipping.status === 'unavailable' || shipping.status === 'error') && shippingCfg.fallbackText) {
        hint.textContent = shippingCfg.fallbackText;
        hint.hidden = false;
      } else {
        hint.textContent = '';
        hint.hidden = true;
      }
    }

    // ---- end freight estimate ---------------------------------------------

    // ---- Builder lead capture (HubSpot) -----------------------------------
    // Sends a HubSpot Forms API submission once the contact block is complete
    // (name + email + phone + ZIP) and a boat is selected, so builders who never
    // place the deposit are still captured as leads. City is sent whenever it's
    // filled but isn't part of that gate, so a lead typed city-last still lands
    // (the signature carries city, so it re-fires and upserts). Debounced while typing,
    // flushed on blur and when the page is hidden. A signature of email + build
    // guards against sending the same build twice, while still recapturing an
    // edited build.

    function bindLeadCapture() {
      if (!leadCfg.enabled) {
        return;
      }
      var fields = root.querySelectorAll(
        '[data-contact-name], [data-contact-email], [data-contact-phone],' +
        ' [data-contact-city], [data-contact-zip]'
      );
      Array.prototype.forEach.call(fields, function(field) {
        field.addEventListener('input', function() {
          clearTimeout(leadDebounce);
          leadDebounce = setTimeout(function() {
            maybeSubmitBuilderLead(false);
          }, 1200);
        });
        field.addEventListener('blur', function() {
          clearTimeout(leadDebounce);
          maybeSubmitBuilderLead(false);
        });
      });
      // Safety net: if they complete the form then leave (tab close, navigate
      // away, or background the page), flush a final capture with sendBeacon.
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
          maybeSubmitBuilderLead(true);
        }
      });
      window.addEventListener('pagehide', function() {
        maybeSubmitBuilderLead(true);
      });
    }

    function leadSignature(contact) {
      return [
        contact.email.toLowerCase(),
        contact.city,
        state.base ? state.base.sku : '',
        state.total,
        state.options.map(function(option) {
          return option.sku + 'x' + option.quantity;
        }).join(',')
      ].join('|');
    }

    function maybeSubmitBuilderLead(useBeacon) {
      if (!leadCfg.enabled || leadInFlight) {
        return;
      }
      var contact = getContactDetails();
      var validEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(contact.email);
      if (!state.base || !contact.name || !validEmail || !contact.phone || !contact.zip) {
        return; // wait until the build and contact block are both complete
      }
      var signature = leadSignature(contact);
      if (signature === lastLeadSignature) {
        return; // this exact build + email was already captured
      }
      lastLeadSignature = signature;
      submitBuilderLead(contact, Boolean(useBeacon));
    }

    // Split "First Last" the same way the deposit webhook does, so the builder
    // lead and the later deposit contact resolve to one HubSpot record.
    function splitName(name) {
      var parts = String(name || '').trim().split(/\s+/);
      return { first: parts.shift() || '', last: parts.join(' ') };
    }

    // Human-readable build for the HubSpot `boat_builder_last_build` property.
    // Reuses the cart line-item properties, minus the raw JSON and the contact
    // fields that are already sent as their own HubSpot properties.
    function buildLeadSummary() {
      var props = buildProperties();
      var lines = [];
      Object.keys(props).forEach(function(key) {
        if (key.charAt(0) === '_' || key.indexOf('Customer ') === 0) {
          return;
        }
        lines.push(key + ': ' + props[key]);
      });
      return lines.join('\n');
    }

    function getHubspotCookie() {
      var match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }

    function submitBuilderLead(contact, useBeacon) {
      var name = splitName(contact.name);
      var props = buildProperties();
      var payload = {
        fields: [
          { name: 'email', value: contact.email },
          { name: 'firstname', value: name.first },
          { name: 'lastname', value: name.last },
          { name: 'phone', value: contact.phone },
          { name: 'city', value: contact.city },
          { name: 'zip', value: contact.zip },
          { name: 'boat_builder_lead', value: 'true' },
          { name: 'boat_builder_last_build', value: buildLeadSummary() },
          { name: 'boat_builder_estimated_total', value: (state.total / 100).toFixed(2) },
          { name: 'boat_builder_build_json', value: props._build_json }
        ],
        context: {
          pageUri: window.location.href,
          pageName: document.title
        }
      };
      var hutk = getHubspotCookie();
      if (hutk) {
        payload.context.hutk = hutk; // stitches the lead to the visitor's HubSpot history
      }
      var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' +
        encodeURIComponent(leadCfg.portalId) + '/' + encodeURIComponent(leadCfg.formGuid);

      // On page-hide there's no time to await fetch; sendBeacon still delivers.
      // A Blob preserves the application/json content type HubSpot expects.
      if (useBeacon && navigator.sendBeacon) {
        try {
          navigator.sendBeacon(url, new Blob([JSON.stringify(payload)], { type: 'application/json' }));
        } catch (err) {
          // best-effort on unload; nothing to recover
        }
        return;
      }

      leadInFlight = true;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      })
        .then(function(response) {
          if (!response.ok) {
            lastLeadSignature = ''; // let a later change retry instead of sticking
            return response.text().then(function(text) {
              console.warn('boat-builder: builder lead capture failed (' + response.status + ')', text.slice(0, 300));
            });
          }
        })
        .catch(function(err) {
          lastLeadSignature = '';
          console.warn('boat-builder: builder lead capture error', err);
        })
        .then(function() {
          leadInFlight = false;
        });
    }
    // ---- end builder lead capture -----------------------------------------

    function validateBuild() {
      var contact = getContactDetails();
      if (!state.base) {
        return 'Choose a boat package before continuing.';
      }

      if (!contact.name || !contact.email || !contact.phone || !contact.city || !contact.zip) {
        return 'Add your name, email, phone, city, and ZIP code before continuing.';
      }

      return '';
    }

    function placeDeposit(button) {
      var error = validateBuild();
      var variantId = getDepositVariantId();
      if (error) {
        showMessage(error, true);
        setStep(3);
        return;
      }

      if (!variantId) {
        showMessage('Select a deposit product before taking deposits.', true);
        return;
      }

      button.disabled = true;
      button.classList.add('btn--loading');

      fetch(root.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: buildProperties()
          }]
        })
      })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || data.status >= 400) {
            throw new Error(data.description || 'The deposit could not be added to the cart.');
          }
          return data;
        });
      })
      .then(function() {
        window.location.href = root.dataset.cartUrl || '/cart';
      })
      .catch(function(err) {
        showMessage(err.message || 'The deposit could not be added to the cart.', true);
        button.disabled = false;
        button.classList.remove('btn--loading');
      });
    }

    function buildProperties() {
      var contact = getContactDetails();
      var properties = {
        'Boat': formatBaseLabel(state.base),
        'Boat SKU': state.base ? state.base.sku : ''
      };

      if (config) {
        config.groups.forEach(function(group) {
          if (group.texasGroup) {
            return;
          }
          var labels = state.options.filter(function(option) {
            return option.groupId === group.id;
          }).map(formatOptionLabel);
          var credit = state.credits.filter(function(c) {
            return c.groupId === group.id;
          })[0];
          if (credit) {
            labels.push('package credit -' + formatMoney(credit.amount));
          }
          if (labels.length) {
            properties[group.title] = labels.join(', ');
          }
        });
      } else {
        properties['Build options'] = 'None';
      }

      var feeTitles = state.options.filter(function(option) {
        return option.texasFee;
      }).map(formatOptionLabel);

      properties['Texas title and tags'] = state.texas ? (feeTitles.join(', ') || 'Included if applicable') : 'No';
      if (state.texas) {
        properties['Public waters use'] = state.publicWaters ? 'Yes' : 'No';
        if (state.fees.length) {
          properties['Texas title & registration'] = state.fees.map(function(fee) {
            return fee.label + ' ' + formatMoney(fee.amount);
          }).join(', ');
          properties['Texas fees total'] = formatMoney(state.feesTotal);
        }
      }
      properties['Estimated subtotal'] = formatMoney(state.subtotal);
      properties['Estimated tax'] = state.texas ? formatMoney(state.tax) : formatMoney(0);
      properties['Estimated total'] = formatMoney(state.total);
      var freight = shippingEstimateForBuild(contact);
      if (freight) {
        properties['Estimated freight'] = formatMoney(freight.amount) + ' to ' +
          (freight.city ? freight.city + ' ' : '') + freight.zip +
          (freight.title ? ' (' + freight.title + ')' : '') + ' — not included in total';
      }
      properties['Customer name'] = contact.name;
      properties['Customer email'] = contact.email;
      properties['Customer phone'] = contact.phone;
      properties['Customer city'] = contact.city;
      properties['Customer ZIP'] = contact.zip;
      properties['Build notes'] = contact.notes || 'None';
      properties['_build_json'] = JSON.stringify(buildJsonPayload(contact));

      return properties;
    }

    // Machine-readable copy of the build for order webhooks (HubSpot workflow).
    // Underscore prefix hides it from the cart/checkout UI. Items are single-key
    // objects — the SKU is the key, the display name the value ("2x " prefix when
    // more than one). A selection larger than the package baseline is split: the
    // baseline portion lands in `included`, the excess in `added`; a package item
    // deselected or reduced below its baseline lands in `removed`. Money values
    // are in cents; pricing here is a browser-side estimate, never authoritative.
    function buildJsonPayload(contact) {
      var included = [];
      var added = [];
      var removed = [];
      var lineItems = [];

      function itemEntry(sku, title, qty) {
        var entry = {};
        entry[sku] = (qty > 1 ? qty + 'x ' : '') + stripTitleMarkers(title);
        return entry;
      }

      function lineItem(sku, name, qty, unitPrice) {
        lineItems.push({ sku: sku, name: name, qty: qty, unitPrice: unitPrice });
      }

      // A charged total that doesn't divide evenly across units (a partial
      // package credit) is emitted as a single "Nx ..." line so the line-item
      // sum stays exactly equal to the estimated total — no per-unit rounding.
      function chargedLine(sku, name, qty, total) {
        if (total % qty === 0) {
          lineItem(sku, name, qty, total / qty);
        } else {
          lineItem(sku, (qty > 1 ? qty + 'x ' : '') + name, 1, total);
        }
      }

      if (state.base) {
        lineItem(state.base.sku, formatBaseLabel(state.base), 1, state.base.price);
      }

      state.options.forEach(function(option) {
        var name = stripTitleMarkers(option.title);
        var includedQty = option.texasFee ? 0 : Math.min(option.quantity, option.includedBaseline);
        var addedQty = option.quantity - includedQty;

        if (!option.texasFee) {
          if (includedQty > 0) {
            included.push(itemEntry(option.sku, option.title, includedQty));
          }
          if (addedQty > 0) {
            added.push(itemEntry(option.sku, option.title, addedQty));
          }
        }

        if (includedQty > 0) {
          if (addedQty === 0 && option.chargedAmount > 0) {
            // Rare: the package allowance didn't fully fund the included units
            // (e.g. a bundled SKU hidden on this boat); keep the charge so the
            // sum invariant holds.
            chargedLine(option.sku, name, includedQty, option.chargedAmount);
          } else {
            lineItem(option.sku, name + ' (included)', includedQty, 0);
          }
        }
        if (addedQty > 0) {
          // chargedAmount is the cost of the non-included portion: the included
          // units are covered by the package allowance in applyAllowancePricing.
          chargedLine(option.sku, name, addedQty, option.chargedAmount);
        }
      });

      state.credits.forEach(function(credit) {
        lineItem('CREDIT-' + credit.groupId, credit.groupTitle + ' package credit', 1, -credit.amount);
      });
      state.fees.forEach(function(fee) {
        lineItem('FEE-' + fee.key, fee.label, 1, fee.amount);
      });
      if (state.tax > 0) {
        lineItem('TAX', 'Estimated sales tax', 1, state.tax);
      }

      Object.keys(state.includedQty).forEach(function(sku) {
        var removedQty = includedQtyOf(sku) - qtyOf(sku);
        var option = config && config.options[sku];
        if (removedQty > 0 && option) {
          removed.push(itemEntry(sku, option.title, removedQty));
        }
      });

      var freight = shippingEstimateForBuild(contact);

      var totals = {
        subtotal: state.subtotal,
        tax: state.tax,
        fees: state.fees.map(function(fee) {
          var entry = {};
          entry[fee.label] = fee.amount;
          return entry;
        }),
        feesTotal: state.feesTotal,
        total: state.total,
        texas: state.texas,
        publicWaters: state.publicWaters
      };
      // v2 with additive keys only: totals.shippingEstimate carries the ShipX
      // freight estimate. The key is present only when an estimate was shown,
      // so payloads without one stay byte-for-byte pre-feature.
      if (freight) {
        totals.shippingEstimate = {
          amount: freight.amount,
          zip: freight.zip,
          city: freight.city,
          title: freight.title,
          quotedAt: new Date().toISOString()
        };
      }

      return {
        // v5, additive: `city` on customer and on totals.shippingEstimate —
        // freight rates on city + ZIP, not ZIP alone, so the quote records the
        // city it was rated for.
        v: 5,
        boat: state.base ? itemEntry(state.base.sku, formatBaseLabel(state.base), 1) : null,
        // v4, additive: the selected package's read-only standard-equipment
        // list (per-variant boat_builder.standard_equipment). The webhook puts
        // it on the boat's HubSpot line item in place of the product library's
        // description. Omitted when the variant has none.
        standardEquipment: standardEquipmentForBase(),
        included: included,
        added: added,
        removed: removed,
        // Ready-to-create HubSpot line items; unitPrice in cents, and
        // sum(qty × unitPrice) always equals totals.total.
        lineItems: lineItems,
        customer: [
          { name: contact.name },
          { email: contact.email },
          { phone: contact.phone },
          { city: contact.city },
          { zip: contact.zip },
          { notes: contact.notes || '' }
        ],
        totals: totals
      };
    }

    function formatBaseLabel(base) {
      if (!base) {
        return '';
      }
      if (!base.productTitle || base.productTitle === base.title) {
        return base.title;
      }
      return base.productTitle + ' — ' + base.title;
    }

    // Admin option titles may carry markers like "(additional)" to tell similar
    // metaobject entries apart; strip them from customer-facing text. Raw titles
    // still go out in _build_json for the webhook side.
    function stripTitleMarkers(title) {
      return String(title || '')
        .replace(/\s*\((?:additional|extra|add-on)\)/gi, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    function formatOptionLabel(option) {
      var label = (option.quantity > 1 ? option.quantity + 'x ' : '') +
        stripTitleMarkers(option.title) +
        (option.sku ? ' (' + option.sku + ')' : '');
      if (option.includedBaseline > 0) {
        label += option.chargedAmount === 0 ? ' [included]' : ' [+' + formatMoney(option.chargedAmount) + ']';
      } else if (option.creditApplied > 0) {
        label += option.chargedAmount === 0 ? ' [included]' : ' [upgrade +' + formatMoney(option.chargedAmount) + ']';
      } else if (option.required) {
        label += ' [required]';
      }
      return label;
    }

    function showMessage(message, isError) {
      var messageEl = root.querySelector(selectors.message);
      if (!messageEl) {
        return;
      }

      messageEl.textContent = message;
      messageEl.hidden = false;
      messageEl.classList.toggle('is-error', Boolean(isError));
    }

    function formatMoney(cents) {
      cents = parseInt(cents || 0, 10);
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }

      return '$' + (cents / 100).toFixed(2);
    }
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
